import { render, staticRenderFns } from "./campaign-cdrs.vue?vue&type=template&id=3e38d2d3&scoped=true"
import script from "./campaign-cdrs.vue?vue&type=script&lang=js"
export * from "./campaign-cdrs.vue?vue&type=script&lang=js"
import style0 from "./campaign-cdrs.vue?vue&type=style&index=0&id=3e38d2d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38d2d3",
  null
  
)

export default component.exports